import { Common } from './common';

export class OrderStateEventLog extends Common {
    public orderID: number;
    public orderCode: string;
}
